var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 20.5H23V24H21.6V20.5ZM18.8 17H20.2V24H18.8V17ZM12.5 24C11.5721 23.9989 10.6825 23.6298 10.0264 22.9736C9.37022 22.3175 9.00111 21.4279 9 20.5H10.4C10.4 20.9153 10.5232 21.3214 10.7539 21.6667C10.9847 22.012 11.3126 22.2812 11.6964 22.4401C12.0801 22.5991 12.5023 22.6407 12.9097 22.5596C13.317 22.4786 13.6912 22.2786 13.9849 21.9849C14.2786 21.6912 14.4786 21.3171 14.5596 20.9097C14.6407 20.5023 14.5991 20.0801 14.4401 19.6964C14.2812 19.3126 14.012 18.9847 13.6667 18.7539C13.3214 18.5232 12.9153 18.4 12.5 18.4V17C13.4283 17 14.3185 17.3687 14.9749 18.0251C15.6313 18.6815 16 19.5717 16 20.5C16 21.4283 15.6313 22.3185 14.9749 22.9749C14.3185 23.6313 13.4283 24 12.5 24Z",
    fill: "#DB1C29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6429 7H8.35714C7.99732 7.00036 7.65233 7.14346 7.39789 7.39789C7.14346 7.65233 7.00036 7.99732 7 8.35714V24.6429C7.00036 25.0027 7.14346 25.3477 7.39789 25.6021C7.65233 25.8565 7.99732 25.9996 8.35714 26H24.6429C25.0026 25.9995 25.3475 25.8563 25.6019 25.6019C25.8563 25.3475 25.9995 25.0026 26 24.6429V8.35714C25.9996 7.99732 25.8565 7.65233 25.6021 7.39789C25.3477 7.14346 25.0027 7.00036 24.6429 7ZM24.6429 13.1071H15.1429V8.35714H24.6429V13.1071ZM13.7857 8.35714V13.1071H8.35714V8.35714H13.7857ZM8.35714 24.6429V14.4643H24.6429L24.6442 24.6429H8.35714Z",
    fill: "#DB1C29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e627e24ab6270340add6d83b19d4f409.svg";
export { ForwardRef as ReactComponent };